import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
import LogoIcon from "../../assets/img/logo.jpg";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import {models, sizes, colors, materials, manufacturing, designs, usage, sizesLeaufer} from "../../assets/constant"; // Erweiterte Filteroptionen

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [submenuVisible, setSubmenuVisible] = useState("");
  const user =     localStorage.getItem("username");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  const handleClick = (destination) => {
    if (location.pathname !== "/") {
      navigate("/#" + destination);
      // Warte kurz, bis die Navigation abgeschlossen ist
      setTimeout(() => {
        const element = document.getElementById(destination);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 50); // 100ms reicht meistens
    } else {
      document.getElementById(destination).scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavigateToTeppiche = () => {
    navigate("/carpets");
  };

  const handleFilterClick = (filterType, filterValue) => {
    navigate(`/carpets?${filterType}=${filterValue}`);
    setDropdownVisible(false);

  };

  const handleLogout = () => {
    // Clear tokens and user data
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");

    // Redirect to login page
    navigate("/");
  };
  return (
      <>
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
        <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
          <NavInner className="container flexSpaceCenter">
            <Div>
              <Img onClick={() => handleClick("home")} className="radius8" src={LogoIcon} alt="logo" />

              <Span className="pointer flexNullCenter" onClick={() => handleClick("home")}>
                <h1 className="font20 extraBold">Teppichhaus</h1>
                <h1 className="font20 extraBold">Hosseinzadeh</h1>
              </Span>

            </Div>

            <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
              <BurgerIcon />
            </BurderWrapper>
            <UlWrapper className="flexNullCenter">
              <Li className="semiBold pointer">
                <span onClick={() => handleClick("home")} style={{ padding: "10px 15px" }}>Home</span>
              </Li>
              <Li
                  className="semiBold font15 pointer"
                  onMouseEnter={() => setDropdownVisible(true)}
                  onMouseLeave={() => {
                    setDropdownVisible(false);
                    setSubmenuVisible("");
                  }}
              >
                <span style={{ padding: "10px 15px" }} onClick={handleNavigateToTeppiche}>Teppiche</span>
                {dropdownVisible && (
                    <DropdownMenu>
                      {["modelle", "massen"].map((category) => (
                          <DropdownGroup
                              key={category}
                              onMouseEnter={() => setSubmenuVisible(category)}
                              onMouseLeave={() => setSubmenuVisible("")}
                          >
                            <DropdownItem onClick={handleNavigateToTeppiche}>{category.charAt(0).toUpperCase() + category.slice(1)}</DropdownItem>
                            {submenuVisible === category && (
                                <Submenu>
                                  {(category === "modelle" ? models :
                                      category === "massen" ? sizes :
                                          category === "farben" ? colors :
                                              category === "materialien" ? materials :
                                                  category === "herstellungsart" ? manufacturing :
                                                      category === "design" ? designs :
                                                          usage).map((item) => (
                                      <SubmenuItem key={item} onClick={() => handleFilterClick(category, item)}>
                                        {sizes.includes(item) ? `ca. ${item} cm` : item}
                                      </SubmenuItem>
                                  ))}
                                </Submenu>
                            )}
                          </DropdownGroup>
                ))}
              </DropdownMenu>
                )}
              </Li>
              <Li
                  className="semiBold font15 pointer"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
              >
                <span onClick={() => handleClick("services")} style={{ padding: "10px 15px" }}>Leistungen</span>
                {dropdownOpen && (

                    <DropdownMenu2 >
                      <DropdownItem onClick={() => handleClick("services")}>Teppichreinigung</DropdownItem>
                      <DropdownItem onClick={() => handleClick("blog")}>Reparaturen</DropdownItem>
                      {/*<DropdownItem onClick={() => handleClick("restauration")}>Restauration</DropdownItem>*/}
                    </DropdownMenu2>
                )}
              </Li>
              <Li className="semiBold font15 pointer" onClick={() => handleClick("contact")}>
                <span style={{ padding: "10px 15px" }}>Kontakte</span>
              </Li>
              <Li className="semiBold font15 pointer" onClick={() =>    navigate("/aboutUs")}>
                <span style={{ padding: "10px 15px" }}>Gleitwort</span>
              </Li>

            </UlWrapper>
            {!user ?(
                <UlWrapperRight className="flexNullCenter">
                  <Li onClick={() =>    navigate("/login")} className="semiBold font15 pointer">
                    <span style={{ padding: "10px 30px 0 0" }}>Anmelden</span>
                  </Li>
                </UlWrapperRight>
              )
              :
              (
                <UlWrapperRight className="flexNullCenter">
                  <Li className="semiBold font15 pointer" onClick={() =>    navigate("/anleitung")}>
                    <span style={{ padding: "10px 0 0 0" }}>Anleitung</span>
                  </Li>
                  {window.location.pathname !== "/admin" && (
                      <Li className="semiBold font15 pointer" onClick={() => navigate("/admin")}>
                        <span  style={{ padding: "10px 15px 0px" }}>
                          Banner
                        </span>
                      </Li>
                  )}

                  <Li className="semiBold font15 pointer" onClick={handleLogout}>
                    <span  style={{ padding: "10px 0 0 0" }}>Abmelden</span>
                  </Li>
                </UlWrapperRight>
              )
            }


          </NavInner>
        </Wrapper>
      </>
  );
}


/* Styled Components */
const Wrapper = styled.nav`
  background-color: #eae9e9;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;

const NavInner = styled.div`
  position: relative;
  height: 100%;
`;

const BurderWrapper = styled.button`
  outline: none;
  border: 0;
  background-color: transparent;
  height: 100%;
  padding: 0 0;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;

const UlWrapper = styled.ul`
  display: flex;
  position: relative;
  @media (max-width: 760px) {
    display: none;
  }
`;

const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;

const Img = styled.img`
  width: 25%;
  max-width: 80px;
  z-index: 9;
  cursor: pointer;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 60px;
  background: #e5e5e5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 10px;
  z-index: 999;
`;

const DropdownMenu2 = styled.div`
  position: absolute;
  top: 100%;
  left: 150px;
  
  background: #e5e5e5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 10px;
  z-index: 999;
`;

const DropdownGroup = styled.div`
  padding: 10px 0;
  position: relative;
`;

const DropdownItem = styled.div`
  padding: 10px 20px;
  cursor: pointer;

  :hover {
    background: #ffffff;
  }
`;

const Submenu = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  background: #e5e5e5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
`;

const SubmenuItem = styled.div`
  width: 150px;
  padding: 8px 1px;
  cursor: pointer;

  :hover {
    background: #ffffff;
    color: #212121;
  }
`;

const Li = styled.li`
font-size: 18px;

  //:hover {
  //  background: #ffffff;
  //}
`;

const Span = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const Div = styled.div`
  display: flex;
  //flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;